import { Box, Button, Stack, Typography } from '@mui/material';
import { LikeIcon } from '../icons/LikeIcon';
import { ConversationIcon } from '../icons/ConversationIcon';
import { FacebookFeedShareIcon } from '../icons/FacebookFeedShareIcon';
import { colors } from 'theme/mui/colors';
import { WorldIcon } from '../icons/WorldIcon';
import { ThumbsUpIcon } from '../icons/ThumbsUpIcon';
import { HeartIcon } from '../icons/HeartIcon';
import { HugIcon } from '../icons/HugIcon';
import { SocialMediaTypes } from 'types/socialMediaTypes';

const FacebookPostPreview = (props: SocialMediaTypes) => {
  const { brandName, imageUrl, postText, title, websiteUrl, brandLogo } = props;
  return (
    <Box
      sx={{
        maxWidth: '19rem',
        margin: '0 auto',
        backgroundColor: 'white',
        border: `1px solid ${colors.base.white}`,
        borderRadius: '0.5rem',
        overflow: 'hidden',
        boxShadow: '0 1px 2px 0 rgba(0.3, 0.3, 0.3, 0.3)',
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" padding="1rem" paddingBottom="0.75rem">
        <Stack direction="row" alignItems="center" gap="0.75rem">
          <Box
            sx={{
              width: '2rem',
              height: '2rem',
              borderRadius: '50%',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <img
              src={brandLogo || '/img/avatar-ads-icon.svg'}
              alt={brandName}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
          <Stack>
            <Stack direction="row" alignItems="center" gap="0.5rem">
              <Typography variant="h6">{brandName}</Typography>
              <Typography variant="body2" color={colors.gray[500]}>
                Sponsored
              </Typography>
              <WorldIcon />
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      {/* Post Text */}
      <Box sx={{ p: '0 1rem', pb: '0.75rem' }}>
        <Typography variant="caption">{postText}</Typography>
      </Box>

      {/* Image */}
      <Box position="relative">
        <img
          src={imageUrl || '/placeholder.svg'}
          alt="Property"
          style={{
            width: '100%',
            height: '12rem',
            objectFit: 'cover',
          }}
        />
      </Box>

      {/* Link Preview Footer */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        p="1rem"
        borderTop={`1px solid ${colors.base.white}`}
      >
        <Box flex={1}>
          <Typography variant="subtitle2">{websiteUrl}</Typography>
          <Typography variant="subtitle2" fontWeight={600}>
            {title}
          </Typography>
        </Box>
        <Button
          sx={{
            backgroundColor: colors.gray[600],
            color: 'white',
            padding: '0.25rem 1rem',
            borderRadius: '0.375rem',
          }}
        >
          Shop Now
        </Button>
      </Stack>

      {/* Engagement Stats */}
      <Box
        sx={{
          p: '0.75rem 1rem',
          bt: `1px solid ${colors.base.white}`,
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" color={colors.gray[600]}>
          <Stack direction="row" gap="0.25rem" alignItems="center">
            <Stack direction="row" alignItems="center" mt="-0.125rem">
              <ThumbsUpIcon />
              <HeartIcon />
              <HugIcon />
            </Stack>
            <Typography ml="0.25rem" variant="body2">
              129
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap="1rem">
            <Typography variant="body2">12 Comments</Typography>
            <Typography variant="body2">8 Shares</Typography>
          </Stack>
        </Stack>
      </Box>

      {/* Action Buttons */}
      <Stack direction="row" alignItems="center" borderTop={`1px solid ${colors.base.white}`}>
        <Button
          startIcon={<LikeIcon style={{ width: '1rem', height: '1rem' }} />}
          sx={{
            cursor: 'pointer',
            flex: 1,
            '& .MuiButton-startIcon': {
              mr: '1px',
            },
          }}
        >
          <Typography variant="body2">Like</Typography>
        </Button>
        <Button
          startIcon={<ConversationIcon style={{ width: '1rem', height: '1rem' }} />}
          sx={{
            cursor: 'pointer',
            flex: 1,
            '& .MuiButton-startIcon': {
              mr: '1px',
            },
          }}
        >
          <Typography variant="body2">Comment</Typography>
        </Button>
        <Button
          startIcon={<FacebookFeedShareIcon style={{ width: '1rem', height: '1rem' }} />}
          sx={{
            cursor: 'pointer',
            flex: 1,
            '& .MuiButton-startIcon': {
              mr: '1px',
            },
          }}
        >
          <Typography variant="body2">Share</Typography>
        </Button>
      </Stack>
    </Box>
  );
};

export default FacebookPostPreview;
